export default __webpack_public_path__ + "static/media/mftv_amediateka.4ac17488.svg";